import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    createQCMaterialSuccess, createQCMaterialFailure,
    getAllQCMaterialsSuccess, getAllQCMaterialsFailure,
    getQCMaterialByIdSuccess, getQCMaterialByIdFailure,
    updateQCMaterialSuccess, updateQCMaterialFailure,
    enterQCResultSuccess, enterQCResultFailure,
    getQCResultsSuccess, getQCResultsFailure,
    reviewQCResultSuccess, reviewQCResultFailure,
    getLeveyJenningsSuccess, getLeveyJenningsFailure,
    getQCSummarySuccess, getQCSummaryFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* createMaterialRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/materials`, requestDetail);
        yield put(createQCMaterialSuccess(response));
    } catch (error) { yield put(createQCMaterialFailure(error?.response?.message || error)); }
}

function* getAllMaterialsRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/materials`, requestDetail);
        yield put(getAllQCMaterialsSuccess(response));
    } catch (error) { yield put(getAllQCMaterialsFailure(error?.response?.message || error)); }
}

function* getMaterialByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/materials/${action.payload}`, requestDetail);
        yield put(getQCMaterialByIdSuccess(response));
    } catch (error) { yield put(getQCMaterialByIdFailure(error?.response?.message || error)); }
}

function* updateMaterialRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/materials`, requestDetail);
        yield put(updateQCMaterialSuccess(response));
    } catch (error) { yield put(updateQCMaterialFailure(error?.response?.message || error)); }
}

function* enterResultRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/results`, requestDetail);
        yield put(enterQCResultSuccess(response));
    } catch (error) { yield put(enterQCResultFailure(error?.response?.message || error)); }
}

function* getResultsRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { page = 1, limit = 50, ...filters } = action.payload || {};
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/results?page=${page}&limit=${limit}`;
        Object.entries(filters).forEach(([k, v]) => { if (v) url += `&${k}=${v}`; });
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getQCResultsSuccess(response));
    } catch (error) { yield put(getQCResultsFailure(error?.response?.message || error)); }
}

function* reviewResultRequest(action) {
    try {
        const { id, ...body } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify(body)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/results/${id}/review`, requestDetail);
        yield put(reviewQCResultSuccess(response));
    } catch (error) { yield put(reviewQCResultFailure(error?.response?.message || error)); }
}

function* leveyJenningsRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { analyzerId, testId, limit = 30 } = action.payload;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/levey-jennings/${analyzerId}/${testId}?limit=${limit}`, requestDetail);
        yield put(getLeveyJenningsSuccess(response));
    } catch (error) { yield put(getLeveyJenningsFailure(error?.response?.message || error)); }
}

function* summaryRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json" }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/qc/summary/${action.payload}`, requestDetail);
        yield put(getQCSummarySuccess(response));
    } catch (error) { yield put(getQCSummaryFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labQC/createQCMaterialRequest', createMaterialRequest);
    yield takeLatest('labQC/getAllQCMaterialsRequest', getAllMaterialsRequest);
    yield takeLatest('labQC/getQCMaterialByIdRequest', getMaterialByIdRequest);
    yield takeLatest('labQC/updateQCMaterialRequest', updateMaterialRequest);
    yield takeLatest('labQC/enterQCResultRequest', enterResultRequest);
    yield takeLatest('labQC/getQCResultsRequest', getResultsRequest);
    yield takeLatest('labQC/reviewQCResultRequest', reviewResultRequest);
    yield takeLatest('labQC/getLeveyJenningsRequest', leveyJenningsRequest);
    yield takeLatest('labQC/getQCSummaryRequest', summaryRequest);
}

export default saga;
